const CONTENT_MATURITY_GRADE_LEVELS = {
  Kindergarten: [-1, 0],
  "Lower Elementary School": [1, 3],
  "Upper Elementary School": [4, 5],
  "Middle School": [6, 8],
  "High School": [9, 12],
};

export default CONTENT_MATURITY_GRADE_LEVELS;
